import { ViewThirdPartyDoc } from "@/ui/compositionRootUI";

const PageThirdPartyDoc = () => {
    return <ViewThirdPartyDoc />;
};

export default PageThirdPartyDoc;
